import {
  HttpContext,
  HttpContextToken,
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isArray } from 'lodash';
import { ApiError } from 'net-api-lib';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs';

export const BYPASS_ERROR_INTERCEPTOR = new HttpContextToken(() => false);

export function bypassErrorInterceptor() {
  return { context: new HttpContext().set(BYPASS_ERROR_INTERCEPTOR, true) };
}

/**
 * Check for error messages in the response and show them as a toast message
 *
 * Interceptor can be bypassed by setting the BYPASS_ERROR_INTERCEPTOR context
 * or use bypassErrorInterceptor() helper function
 *
 * sample how to bypass: https://stackoverflow.com/a/68834287/4049371
 */
export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const translate = inject(TranslateService);
  const toastr = inject(ToastrService);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (!req.context.get(BYPASS_ERROR_INTERCEPTOR) && err) {
        switch (err.status) {
          case 400:
            if (err.error?.isSuccess == false && isArray(err.error?.errors)) {
              let message = '';
              if (err.error.errors?.length) {
                message = `<ul>${err.error.errors
                  .map((e: ApiError) => {
                    const errorMsg = e.message
                      ? translate.instant(e.message, e.metadata as object)
                      : JSON.stringify(e);

                    return `<li>${errorMsg}</li>`;
                  })
                  .join('\n')}</ul>`;
              }

              toastr.error(message, undefined, { enableHtml: true });
            }
            break;
          case 500:
            if (err.error?.detail) toastr.error(err.error.detail);
            break;
        }
      }
      throw err;
    })
  );
};
